
export class ChatCommentValidator {

    public isCommentValid(commentText: string) : boolean {
        return commentText.trim().length !== 0;
    }
}